import { render, staticRenderFns } from "./BaseToggleInput.vue?vue&type=template&id=995fba66"
import script from "./BaseToggleInput.vue?vue&type=script&lang=js"
export * from "./BaseToggleInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports